import user from "./user";
import shop from "./shop";
import order from "./order";
import activity from "./activity";
import article from "./article";

export default [...user, ...shop, ...order, ...activity, ...article];
